import { sanitizeTextForAnalytics } from "@/utils/helper"

export const accordianAnalyticsData = (
  type = "",
  isExpanded = false,
  needsJSON = false
) => {
  const title = type.toLowerCase().trim()
  const eventInfo = {
    eventAction: `pdp:product details:accordion ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventName: `pdp:product details:accordion ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${isExpanded ? "collapse" : "expand"}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${title}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const getEventInfoInstSup = (
  title = "",
  type = "",
  avoidTitle = false,
  url = ""
) => {
  if (typeof window !== "undefined") {
    const addedTitle = avoidTitle
      ? ""
      : (type ? ":" : "") + sanitizeTextForAnalytics(title)
    return JSON.stringify({
      eventAction: `pdp:installation and support:${type}${addedTitle}`,
      eventName: `pdp:installation and support:${type}${addedTitle}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: sanitizeTextForAnalytics(title),
      internalLinkPosition: "pdp",
      internalLinkType: "pdp:navigation",
      internalLinkZoneName: "pdp:installation and support",
      internalLinkURL: url
        ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
        : "n/a",
      clickInternalLinks: "true",
    })
  }
}

export const getEventInfoProdAccordion = (
  type = "",
  needsJSON = false,
  link = "",
  errMsg = ""
) => {
  if (typeof window !== "undefined") {
    const text = type.toLowerCase().trim()
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const eventMsg = text === "view more" ? "n/a" : errMsg || "success"
    const eventStatus =
      text === "view more" ? "n/a" : errMsg ? "failure" : "success"
    const internalLinkName = `${text}${
      text === "specifications sheet"
        ? ` | ${link.replace("https://www.us.kohler.com/webassets", "")}`
        : ""
    }`
    const eventInfo = {
      eventAction: `${page?.category?.pageType}:specs:${text}`,
      eventName: `${page?.category?.pageType}:specs:${text}`,
      eventType: "navigation",
      eventMsg,
      eventStatus,
      internalLinkName,
      internalLinkPosition: `${page?.category?.pageType}`,
      internalLinkType: `${page?.category?.pageType}:specs:${text}`,
      internalLinkZoneName: `${page?.category?.pageType}:specs`,
      internalLinkURL: link,
      clickInternalLinks: "true",
    }
    if (needsJSON) {
      return eventInfo
    }
    return JSON.stringify(eventInfo)
  }
}

export * from "../../../../src/components/ProductDetail/v3/ProductAccordionList/analytics"
